import { useEffect } from 'react'
import { EventNames } from '../../../types/misc.types'
import { trackEvent } from '../../../utils/appBridge'
import BottomSheetContent from '../BottomSheetContent'

export const UniWealthCompliance = ({ onDismiss, ScreenName }: { onDismiss: () => void; ScreenName: string }) => {
  useEffect(() => {
    trackEvent({
      eventName: EventNames.KnowMoreBottomSheetLoad,
      payload: {
        eventId: 'UniWealthCompliance',
        ScreenName
      }
    })
  }, [])
  return (
    <BottomSheetContent heading='Transactions via Uniorbit Wealth EOP' onDismiss={onDismiss}>
      <div className='text-[#6A6E6E] text-[14px] font-[400] leading-[150%]'>
        This transaction is powered via Uniorbit Wealth’s SEBI-registered Execution Only Platform (EOP) license
        34939239. Uniorbit Wealth EOP does not offer any fund advice or recommendations.
      </div>
    </BottomSheetContent>
  )
}
